import * as React from 'react';

import {
  BooleanField,
  Datagrid,
  DateField,
  List,
  TextField,
  useTranslate,
} from 'react-admin';
import { Theme, useMediaQuery } from '@mui/material';

import MobileGrid from './MobileGrid';

const PriceList = () => {
  const isXsmall = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm')
  );
  const translate = useTranslate();

  return (
    <List bulkActionButtons={false} title={translate('pos.menu.price')}>
      {isXsmall ? (
        <MobileGrid />
      ) : (
        <Datagrid rowClick="edit">
          <TextField source="name" label={translate('resources.price.fields.name')} />
          <DateField source="date" label={translate('resources.price.fields.date')} showTime />
          <BooleanField source="active" label={translate('resources.price.fields.active')} />
        </Datagrid>
      )}
    </List>
  );
};

export default PriceList;
